export const BLOCK_TYPE_SPECIAL = "special";
export const BLOCK_TYPE_COMMON = "common";
export const BLOCK_TYPE_MATERIAL = "material";
export const BLOCK_TYPE_ANIMATION = "animation";
export const STORE_PRODUCT_ACCESS_PURCHASE = "purchase";
export const STORE_PRODUCT_ACCESS_EARNED_TOP_PLAYER = "earned_top_player";
export const TOP_WINNER_MODE_SKIN_BY_MODE = Object.freeze({
  ciencia: "x1",
  cienzar: "x4",
  sciencevsazar: "x2",
  azar: "x3",
});

const PRODUCT_ID_PATTERN = /^[a-z0-9][a-z0-9_-]*$/;
const MAX_STORE_PRODUCT_ID_LENGTH = 80;
const HIDDEN_BLOCK_ANIMATION_IDS = new Set([
  "burning-crystal-cube",
  "robot-cube",
  "liquid-glass-cube",
  "gift-box",
]);

export const normalizeStoreProductId = (value) => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase();
  if (!normalized) return "";
  if (normalized.length > MAX_STORE_PRODUCT_ID_LENGTH) return "";
  if (!PRODUCT_ID_PATTERN.test(normalized)) return "";
  return normalized;
};

const normalizeSkinId = (value) =>
  String(value || "")
    .trim()
    .replace(/^skins\//i, "")
    .replace(/\.[a-z0-9]+$/i, "");

const extractSkinIdFromAssetPath = (assetPath) => {
  const rawPath = String(assetPath || "").trim();
  if (!rawPath) return "";

  const sanitizedPath = rawPath.split("?")[0].split("#")[0];
  const segments = sanitizedPath.split(/[\\/]/).filter(Boolean);
  if (segments.length === 0) return "";

  let filename = segments[segments.length - 1];
  try {
    filename = decodeURIComponent(filename);
  } catch {
    // Keep original filename when URL decode fails.
  }

  return normalizeSkinId(filename);
};

const resolveSkinIdsFromStoreProductAssets = (product) => {
  const directIds = Array.isArray(product?.skinIds)
    ? product.skinIds.map((entry) => normalizeSkinId(entry)).filter(Boolean)
    : [];

  const galleryAssets = Array.isArray(product?.gallery) ? product.gallery : [];
  const allAssets = [product?.image, ...galleryAssets];
  const derivedIds = allAssets.map((assetPath) => extractSkinIdFromAssetPath(assetPath)).filter(Boolean);

  return Array.from(new Set([...directIds, ...derivedIds]));
};

export const SPECIAL_BLOCK_PRODUCTS = [
  {
    id: "nebula-star",
    blockType: BLOCK_TYPE_SPECIAL,
    accessType: STORE_PRODUCT_ACCESS_PURCHASE,
    image: "/skins-store/special/pelotas/pelota1.png",
    gallery: [
      "/skins-store/special/pelotas/pelota1.png",
      "/skins-store/special/pelotas/pelota2.png",
      "/skins-store/special/pelotas/pelota3.png",
      "/skins-store/special/pelotas/pelota4.png",
    ],
    skinIds: ["pelota1", "pelota2", "pelota3", "pelota4"],
    name: {
      es: "PELOTAS FLUORECENTES",
      en: "FLUORESCENT BALLS",
      ru: "ФЛУОРЕСЦЕНТНЫЕ ШАРЫ",
      de: "FLUCHTSCHALTENDE KUGELN",
    },
    description: {
      es: "4 colores de pelotas de neon fluorecente para tu bloque especial.",
      en: "4 colors of fluorescent neon balls for your special block.",
      ru: "4 цвета флуоресцентных неоновых шаров для вашего специального блока.",
      de: "4 Farben fluoreszierender Neonkugeln für deinen Spezialblock.",
    },
    price: "50 X",
  },
  {
    id: "frog-pulse",
    blockType: BLOCK_TYPE_SPECIAL,
    accessType: STORE_PRODUCT_ACCESS_PURCHASE,
    image: "/skins-store/special/the-best/thebest1.png",
    gallery: [
      "/skins-store/special/the-best/thebest1.png",
      "/skins-store/special/the-best/thebest2.png",
      "/skins-store/special/the-best/thebest3.png",
      "/skins-store/special/the-best/thebest4.png",
    ],
    skinIds: ["thebest1", "thebest2", "thebest3", "thebest4"],
    name: {
      es: "THE BEST",
      en: "THE BEST",
      ru: "ЛУЧШЕЕ",
      de: "DAS BESTE",
    },
    description: {
      es: "Exelente mensaje indirecto que mostrara quien es el que manda.",
      en: "An excellent subtle message that shows who's in charge.",
      ru: "Отличное ненавязчивое послание, показывающее, кто здесь главный.",
      de: "Eine dezente Botschaft, die zeigt, wer das Sagen hat.",
    },
    price: "50 X",
  },
  {
    id: "damas-xima",
    blockType: BLOCK_TYPE_SPECIAL,
    accessType: STORE_PRODUCT_ACCESS_PURCHASE,
    image: "/skins-store/special/damas-xima/dama1.png",
    gallery: [
      "/skins-store/special/damas-xima/dama1.png",
      "/skins-store/special/damas-xima/dama2.png",
      "/skins-store/special/damas-xima/dama3.png",
      "/skins-store/special/damas-xima/dama4.png",
    ],
    skinIds: ["dama1", "dama2", "dama3", "dama4"],
    name: {
      es: "DAMAS XIMA",
      en: "XIMA CHECKERS",
      ru: "XIMA CHECKERS",
      de: "XIMA DAMEN",
    },
    description: {
      es: "Coleccion de 4 skins de damas para bloques especiales.",
      en: "Collection of 4 checker skins for special blocks.",
      ru: "Collection of 4 checker skins for special blocks.",
      de: "Sammlung mit 4 Dame-Skins fuer Spezialbloecke.",
    },
    price: "50 X",
  },
  {
    id: "logo-xima-ciencia",
    blockType: BLOCK_TYPE_SPECIAL,
    accessType: STORE_PRODUCT_ACCESS_EARNED_TOP_PLAYER,
    earnedMode: "ciencia",
    image: "/skins-store/special/logo-xima/x1.png",
    gallery: ["/skins-store/special/logo-xima/x1.png"],
    skinIds: ["x1"],
    name: {
      es: "LOGO XIMA CIENCIA",
      en: "XIMA LOGO SCIENCE",
      ru: "ЛОГОТИП XIMA SCIENCE",
      de: "XIMA-LOGO WISSENSCHAFT",
    },
    description: {
      es: "Skin Azul del Logo XIMA. Disponible unicamente para el mejor jugador del modo Ciencia. Al finalizar cada mes, el jugador que posea esta skin podra reclamar una recompensa de 200000X.",
      en: "Blue XIMA Logo Skin. Available only for the best player in Science mode. At the end of each month, the player who owns this skin will be able to claim a reward of 200000X.",
      ru: "Синий скин логотипа XIMA. Доступен только для лучшего игрока режима Наука. В конце каждого месяца игрок, владеющий этим скином, сможет получить награду в размере 200000X.",
      de: "Blauer XIMA-Logo-Skin. Nur fuer den besten Spieler im Wissenschaftsmodus verfuegbar. Am Ende jedes Monats kann der Spieler, der diesen Skin besitzt, eine Belohnung von 200000X erhalten.",
    },
    price: "GANADO",
    buyLabel: "GANAR",
  },
  {
    id: "logo-xima-reservado",
    blockType: BLOCK_TYPE_SPECIAL,
    accessType: STORE_PRODUCT_ACCESS_EARNED_TOP_PLAYER,
    earnedMode: "sciencevsazar",
    image: "/skins-store/special/logo-xima/x2.png",
    gallery: ["/skins-store/special/logo-xima/x2.png"],
    skinIds: ["x2"],
    name: {
      es: "LOGO XIMA CONTRAZAR",
      en: "XIMA LOGO CONTRAZAR",
      ru: "XIMA LOGO CONTRAZAR",
      de: "XIMA-LOGO CONTRAZAR",
    },
    description: {
      es: "Skin rojo del logo XIMA para el mejor jugador del modo Contrazar.",
      en: "Red XIMA logo skin for the top Contrazar player.",
      ru: "Red XIMA logo skin for the top Contrazar player.",
      de: "Roter XIMA-Logo-Skin fuer den besten Contrazar-Spieler.",
    },
    price: "GANADO",
    buyLabel: "GANAR",
  },
  {
    id: "logo-xima-azar",
    blockType: BLOCK_TYPE_SPECIAL,
    accessType: STORE_PRODUCT_ACCESS_EARNED_TOP_PLAYER,
    earnedMode: "azar",
    image: "/skins-store/special/logo-xima/x3.png",
    gallery: ["/skins-store/special/logo-xima/x3.png"],
    skinIds: ["x3"],
    name: {
      es: "LOGO XIMA AZAR",
      en: "XIMA LOGO CHANCE",
      ru: "ШАНС НА ЛОГОТИП XIMA",
      de: "XIMA-LOGO CHANCE",
    },
    description: {
      es: "Skin amarillo del logo XIMA para el mejor jugador del modo Azar.",
      en: "Yellow XIMA logo skin for the top Chance player.",
      ru: "Yellow XIMA logo skin for the top Chance player.",
      de: "Gelber XIMA-Logo-Skin fuer den besten Zufall-Spieler.",
    },
    price: "GANADO",
    buyLabel: "GANAR",
  },
  {
    id: "logo-xima-cienzar",
    blockType: BLOCK_TYPE_SPECIAL,
    accessType: STORE_PRODUCT_ACCESS_EARNED_TOP_PLAYER,
    earnedMode: "cienzar",
    image: "/skins-store/special/logo-xima/x4.png",
    gallery: ["/skins-store/special/logo-xima/x4.png"],
    skinIds: ["x4"],
    name: {
      es: "LOGO XIMA CIENZAR",
      en: "XIMA LOGO SCIENZAR",
      ru: "ЛОГОТИП XIMA SCIENZAR",
      de: "XIMA-LOGO SCIENZAR",
    },
    description: {
      es: "Skin verde del logo XIMA para el mejor jugador del modo Cienzar.",
      en: "Green XIMA logo skin for the top Cienzar player.",
      ru: "XIMA Scienzar skin.",
      de: "XIMA Scienzar Skin.",
    },
    price: "GANADO",
    buyLabel: "GANAR",
  },
  {
    id: "dragon-core",
    blockType: BLOCK_TYPE_SPECIAL,
    accessType: STORE_PRODUCT_ACCESS_PURCHASE,
    image: "/skins-store/special/constelacion-estrellas/estrella1.png",
    gallery: [
      "/skins-store/special/constelacion-estrellas/estrella1.png",
      "/skins-store/special/constelacion-estrellas/estrella2.png",
      "/skins-store/special/constelacion-estrellas/estrella3.png",
      "/skins-store/special/constelacion-estrellas/estrella4.png",
    ],
    skinIds: ["estrella1", "estrella2", "estrella3", "estrella4"],
    name: {
      es: "CONTELACION DE ESTRELLAS",
      en: "STAR CONSTELLATION",
      ru: "ЗВЕЗДНОЕ СОЗВЕЗДИЕ",
      de: "STERNENKONSTELLATION",
    },
    description: {
      es: "Nada mas hermoso que una estrella cuando esta en la cima.",
      en: "Nothing is more beautiful than a star at the top.",
      ru: "Нет ничего прекраснее звезды на вершине.",
      de: "Nichts ist schöner als ein Stern am Himmel.",
    },
    price: "50 X",
  },
];

export const COMMON_BLOCK_PRODUCTS = [
  {
    id: "common-grid-0",
    blockType: BLOCK_TYPE_COMMON,
    accessType: STORE_PRODUCT_ACCESS_PURCHASE,
    image: "/skins-store/common/coral/image1-0d.png",
    gallery: [
      "/skins-store/common/coral/image1-0d.png",
      "/skins-store/common/coral/image1-77.png",
      "/skins-store/common/coral/image1-8d.png",
      "/skins-store/common/coral/image1-9s.png",
    ],
    skinIds: ["image1-0", "image1-0d", "image1-77", "image1-8d", "image1-9s"],
    name: {
      es: "Coral",
      en: "Coral",
      ru: "Coral",
      de: "Coral",
    },
    description: {
      es: "Coleccion Coral para bloques comunes.",
      en: "Coral collection for common blocks.",
      ru: "Coral collection for common blocks.",
      de: "Coral-Kollektion fuer normale Bloecke.",
    },
    price: "50 X",
  },
  {
    id: "common-grid-17",
    blockType: BLOCK_TYPE_COMMON,
    accessType: STORE_PRODUCT_ACCESS_PURCHASE,
    image: "/skins-store/common/futuro/image1-01.png",
    gallery: [
      "/skins-store/common/futuro/image1-01.png",
      "/skins-store/common/futuro/image1-73.png",
      "/skins-store/common/futuro/image1-76.png",
      "/skins-store/common/futuro/image1-96.png",
    ],
    skinIds: ["image1-17", "image1-01", "image1-73", "image1-76", "image1-96"],
    name: {
      es: "Futuro",
      en: "Futuro",
      ru: "Futuro",
      de: "Futuro",
    },
    description: {
      es: "Coleccion Futuro para bloques comunes.",
      en: "Futuro collection for common blocks.",
      ru: "Futuro collection for common blocks.",
      de: "Futuro-Kollektion fuer normale Bloecke.",
    },
    price: "50 X",
  },
  {
    id: "common-grid-61",
    blockType: BLOCK_TYPE_COMMON,
    accessType: STORE_PRODUCT_ACCESS_PURCHASE,
    image: "/skins-store/common/libre/image1-27sdfsd.png",
    gallery: [
      "/skins-store/common/libre/image1-27sdfsd.png",
      "/skins-store/common/libre/image1-34fcsd.png",
      "/skins-store/common/libre/image1-3drfgdfg.png",
      "/skins-store/common/libre/image1-6drfgdfgd.png",
    ],
    skinIds: ["image1-61", "image1-27sdfsd", "image1-34fcsd", "image1-3drfgdfg", "image1-6drfgdfgd"],
    name: {
      es: "Libre",
      en: "Libre",
      ru: "Libre",
      de: "Libre",
    },
    description: {
      es: "Coleccion Libre para bloques comunes.",
      en: "Libre collection for common blocks.",
      ru: "Libre collection for common blocks.",
      de: "Libre-Kollektion fuer normale Bloecke.",
    },
    price: "50 X",
  },
  {
    id: "common-grid-65",
    blockType: BLOCK_TYPE_COMMON,
    accessType: STORE_PRODUCT_ACCESS_PURCHASE,
    image: "/skins-store/common/romano/image1-1sdaf.png",
    gallery: [
      "/skins-store/common/romano/image1-1sdaf.png",
      "/skins-store/common/romano/image1-2dsfgdf.png",
      "/skins-store/common/romano/image1-7ds.png",
      "/skins-store/common/romano/image1sdfgsd.png",
    ],
    skinIds: ["image1-65", "image1-1sdaf", "image1-2dsfgdf", "image1-7ds", "image1sdfgsd"],
    name: {
      es: "Romano",
      en: "Romano",
      ru: "Romano",
      de: "Romano",
    },
    description: {
      es: "Coleccion Romano para bloques comunes.",
      en: "Romano collection for common blocks.",
      ru: "Romano collection for common blocks.",
      de: "Romano-Kollektion fuer normale Bloecke.",
    },
    price: "50 X",
  },
];

export const MATERIAL_TEXTURE_PRODUCTS = [
  { id: "material-paving-stones-138", materialTextureId: "paving-stones-138", image: "/material-textures/paving-stones-138/preview.png", label: "Paving Stones 138" },
  { id: "material-aged-brick", materialTextureId: "aged-brick", image: "/material-textures/aged-brick/preview.png", label: "Ladrillo envejecido" },
  { id: "material-metal-048a", materialTextureId: "metal-048a", image: "/material-textures/metal-048a/preview.png", label: "Metal 048A" },
  { id: "material-onyx-006", materialTextureId: "onyx-006", image: "/material-textures/onyx-006/preview.png", label: "Onyx 006" },
  { id: "material-paving-stones-076", materialTextureId: "paving-stones-076", image: "/material-textures/paving-stones-076/preview.png", label: "Paving Stones 076" },
  { id: "material-tiles-031", materialTextureId: "tiles-031", image: "/material-textures/tiles-031/preview.png", label: "Tiles 031" },
  { id: "material-tiles-100", materialTextureId: "tiles-100", image: "/material-textures/tiles-100/preview.png", label: "Tiles 100" },
  { id: "material-wood-floor-035", materialTextureId: "wood-floor-035", image: "/material-textures/wood-floor-035/preview.png", label: "Wood Floor 035" },
  { id: "material-toxic-lava", materialTextureId: "toxic-lava", image: "/material-textures/toxic-lava/preview.png", label: "Lava tóxica" },
  { id: "material-wet-lava", materialTextureId: "wet-lava", image: "/material-textures/wet-lava/preview.png", label: "Lava húmeda" },
  { id: "material-toxic-basalt-flow", materialTextureId: "toxic-basalt-flow", image: "/material-textures/toxic-basalt-flow/preview.png", label: "Basalto tóxico" },
  { id: "material-wet-grass-droplets", materialTextureId: "wet-grass-droplets", image: "/material-textures/wet-grass-droplets/preview.png", label: "Gotas sobre césped" },
  { id: "material-iridescent-panels", materialTextureId: "iridescent-panels", image: "/material-textures/iridescent-panels/preview.png", label: "Paneles iridiscentes" },
  { id: "material-purple-satin", materialTextureId: "purple-satin", image: "/material-textures/purple-satin/preview.png", label: "Satín morado" },
  { id: "material-alcohol-ink", materialTextureId: "alcohol-ink", image: "/material-textures/alcohol-ink/preview.png", label: "Tinta de alcohol" },
].map((product) => ({
  ...product,
  blockType: BLOCK_TYPE_MATERIAL,
  accessType: STORE_PRODUCT_ACCESS_PURCHASE,
  skinIds: [product.materialTextureId],
  gallery: [product.image],
  name: { es: product.label, en: product.label, de: product.label, ru: product.label },
  description: {
    es: "Textura PBR para aplicar tanto a tus bloques como a las paredes del tablero.",
    en: "PBR texture for both your blocks and board walls.",
    de: "PBR-Textur fuer deine Bloecke und die Waende des Spielbretts.",
    ru: "PBR texture for blocks and board walls.",
  },
  defaultPriceX: 5000,
  price: "5,000 X",
}));

export const BLOCK_ANIMATION_PRODUCTS = [
  {
    id: "animation-animated-rubiks-cube",
    animationId: "animated-rubiks-cube",
    image: "/block-animations/animated-rubiks-cube.svg",
    label: "Animated Rubik's Cube",
    summary: "Rubik de 27 piezas con giros legales coordinados.",
  },
  { id: "animation-smart-cube", animationId: "smart-cube", image: "/block-animations/smart-cube.svg", label: "Cubo inteligente", summary: "Diseño tecnológico multicolor optimizado para WebGL." },
  { id: "animation-locked-up-cubes", animationId: "locked-up-cubes", image: "/block-animations/locked-up-cubes.svg", label: "Cubos encadenados", summary: "Modelo animado con movimiento interno continuo." },
  { id: "animation-tesseract-cube", animationId: "tesseract-cube", image: "/block-animations/tesseract-cube.svg", label: "Cubo teseracto", summary: "Apariencia dimensional de ciencia ficción." },
  { id: "animation-toon-outlined-cube", animationId: "toon-outlined-cube", image: "/block-animations/toon-outlined-cube.svg", label: "Cubo contorno toon", summary: "Diseño estilizado con bordes marcados." },
  { id: "animation-rounded-cube", animationId: "rounded-cube", image: "/block-animations/rounded-cube.svg", label: "Cubo redondeado", summary: "Volumen suave y limpio con esquinas redondeadas." },
  { id: "animation-mirror-rubik-silver", animationId: "mirror-rubik-silver", image: "/block-animations/mirror-rubik-silver.svg", label: "Rubik espejo plata", summary: "Rubik espejo metálico con giros legales de nueve piezas." },
  { id: "animation-mirror-rubik-gold", animationId: "mirror-rubik-gold", image: "/block-animations/mirror-rubik-gold.svg", label: "Rubik espejo oro", summary: "Rubik espejo dorado con giros legales de nueve piezas." },
  { id: "animation-reflective-cube", animationId: "reflective-cube", image: "/block-animations/reflective-cube.svg", label: "Cubo reflectante", summary: "Carcasa reflectante con interior visible." },
  { id: "animation-companion-cube", animationId: "companion-cube", image: "/block-animations/companion-cube.svg", label: "Cubo compañero", summary: "Diseño mecánico inspirado en un cubo compañero." },
  { id: "animation-pokeball", animationId: "pokeball", image: "/block-animations/pokeball.svg", label: "Pokébola", summary: "Modelo esférico coleccionable adaptado al bloque lógico." },
  { id: "animation-puzzle-cube", animationId: "puzzle-cube", image: "/block-animations/puzzle-cube.svg", label: "Puzzle Cube XIMA", summary: "Diseño de rompecabezas tridimensional adaptado al bloque lógico." },
  { id: "animation-cube-truck", animationId: "cube-truck", image: "/block-animations/cube-truck.svg", label: "Guagua cubo", summary: "Vehículo futurista del archivo Blender, adaptado al volumen del bloque." },
  { id: "animation-puzzle-cube-jigsaw", animationId: "puzzle-cube-jigsaw", image: "/block-animations/puzzle-cube-jigsaw.svg", label: "Puzzle Jigsaw XIMA", summary: "Rompecabezas cúbico multicolor de 25 piezas visuales." },
  { id: "animation-sci-fi-cube", animationId: "sci-fi-cube", image: "/block-animations/sci-fi-cube.svg", label: "Cubo de ciencia ficción", summary: "Cubo tecnológico con materiales PBR metálicos de alta definición." },
  { id: "animation-voxel-core-cube", animationId: "voxel-core-cube", image: "/block-animations/voxel-core-cube.svg", label: "Cubo vóxel 3D", summary: "Mil piezas metálicas rodean un núcleo luminoso con pulso dinámico." },
  { id: "animation-abstract-spinning-cube", animationId: "abstract-spinning-cube", image: "/block-animations/abstract-spinning-cube.png", label: "Cubo abstracto giratorio", summary: "Estructura geométrica multicolor con rotación lenta continua." },
  { id: "animation-water-tank", animationId: "water-tank", image: "/block-animations/water-tank.png", label: "Tanque de agua", summary: "Depósito cúbico transparente con armazón metálico." },
  { id: "animation-energy-crate", animationId: "energy-crate", image: "/block-animations/energy-crate.png", label: "Caja de energía", summary: "Caja futurista PBR con etiquetas y detalles luminosos." },
  { id: "animation-neon-cage-cube", animationId: "neon-cage-cube", image: "/block-animations/neon-cage-cube.png", label: "Jaula de neón", summary: "Jaula tridimensional optimizada con rejillas cian y moradas." },
  { id: "animation-burning-crystal-cube", animationId: "burning-crystal-cube", image: "/block-animations/burning-crystal-cube.png", label: "Cristal ardiente", summary: "Cubo cristalino animado con brillo rojo y naranja incandescente." },
  { id: "animation-gear-cube", animationId: "gear-cube", image: "/block-animations/gear-cube.png", label: "Cubo de engranajes", summary: "Nueve engranajes metálicos con rotaciones coordinadas." },
  { id: "animation-robot-cube", animationId: "robot-cube", image: "/block-animations/robot-cube.png", label: "Cubo robot", summary: "Robot cúbico detallado con apariencia tecnológica." },
  { id: "animation-futuristic-die", animationId: "futuristic-die", image: "/block-animations/futuristic-die.png", label: "Dado futurista", summary: "Dado redondeado de acabado metálico y estilo moderno." },
  { id: "animation-impossible-cube", animationId: "impossible-cube", image: "/block-animations/impossible-cube.png", label: "Cubo imposible", summary: "Ilusión geométrica abierta con bordes verdes luminosos." },
  { id: "animation-gift-box", animationId: "gift-box", image: "/block-animations/gift-box.png", label: "Caja de regalo", summary: "Regalo decorado con cinta, lazo y motivos festivos." },
  { id: "animation-one-line-cube", animationId: "one-line-cube", image: "/block-animations/one-line-cube.png", label: "Cubo de una línea", summary: "Estructura continua de neón que dibuja un cubo abierto." },
  { id: "animation-sci-fi-crate", animationId: "sci-fi-crate", image: "/block-animations/sci-fi-crate.png", label: "Caja de ciencia ficción", summary: "Contenedor industrial ligero con textura PBR de alta definición." },
  { id: "animation-liquid-glass-cube", animationId: "liquid-glass-cube", image: "/block-animations/liquid-glass-cube.png", label: "Cubo líquido", summary: "Superficie acuática ondulada con pulso y balanceo continuo." },
  { id: "animation-classic-rubik-cube", animationId: "classic-rubik-cube", image: "/block-animations/classic-rubik-cube.png", label: "Rubik clásico 4x4", summary: "Rubik multicolor de cuatro capas con rotación lenta de exhibición." },
].filter((product) => !HIDDEN_BLOCK_ANIMATION_IDS.has(product.animationId)).map((product) => ({
  ...product,
  blockType: BLOCK_TYPE_ANIMATION,
  accessType: STORE_PRODUCT_ACCESS_PURCHASE,
  skinIds: [product.animationId],
  gallery: [product.image],
  name: { es: product.label, en: product.label, de: product.label, ru: product.label },
  description: {
    es: `${product.summary} Conserva todas las funciones del juego.`,
    en: "Animated 3D model for your common blocks. All gameplay behavior is preserved.",
    de: "Animiertes 3D-Modell fuer deine normalen Bloecke. Alle Spielfunktionen bleiben erhalten.",
    ru: "Animated 3D model for common blocks with all gameplay behavior preserved.",
  },
  defaultPriceX: 5000,
  price: "5,000 X",
}));

export const GIFT_CARD_PRODUCTS = [
  {
    id: "targeta-de-10",
    blockType: BLOCK_TYPE_SPECIAL,
    accessType: STORE_PRODUCT_ACCESS_PURCHASE,
    image: "/store/targeta-de-10.png",
    gallery: ["/store/targeta-de-10.png"],
    defaultPriceX: 50000,
    name: {
      es: "Tarjeta de 10",
      en: "Card Of 10",
      ru: "\u041a\u0430\u0440\u0442\u0430 \u0434\u043b\u044f 10",
      de: "Karte von 10",
    },
    description: {
      es: "El equipo de XIMA comprara una tarjeta de regalo y te la enviara a la informacion que proporciones.",
      en: "The XIMA team will purchase a gift card and send it to the information you provide.",
      ru: "\u041a\u043e\u043c\u0430\u043d\u0434\u0430 XIMA \u043f\u0440\u0438\u043e\u0431\u0440\u0435\u0442\u0451\u0442 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u0443\u044e \u043a\u0430\u0440\u0442\u0443 \u0438 \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442 \u0435\u0451 \u043d\u0430 \u043f\u0440\u0435\u0434\u043e\u0441\u0442\u0430\u0432\u043b\u0435\u043d\u043d\u044b\u0435 \u0432\u0430\u043c\u0438 \u0434\u0430\u043d\u043d\u044b\u0435.",
      de: "Das XIMA-Team wird eine Geschenkkarte kaufen und sie an die von dir angegebenen Informationen senden.",
    },
    price: "50,000 X",
  },
  {
    id: "targeta-de-20",
    blockType: BLOCK_TYPE_SPECIAL,
    accessType: STORE_PRODUCT_ACCESS_PURCHASE,
    image: "/store/targeta-de-20.png",
    gallery: ["/store/targeta-de-20.png"],
    defaultPriceX: 100000,
    name: {
      es: "Tarjeta de 20",
      en: "Card Of 20",
      ru: "\u041a\u0430\u0440\u0442\u0430 \u0434\u043b\u044f 20",
      de: "Karte von 20",
    },
    description: {
      es: "El equipo de XIMA comprara una tarjeta de regalo y te la enviara a la informacion que proporciones.",
      en: "The XIMA team will purchase a gift card and send it to the information you provide.",
      ru: "\u041a\u043e\u043c\u0430\u043d\u0434\u0430 XIMA \u043f\u0440\u0438\u043e\u0431\u0440\u0435\u0442\u0451\u0442 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u0443\u044e \u043a\u0430\u0440\u0442\u0443 \u0438 \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442 \u0435\u0451 \u043d\u0430 \u043f\u0440\u0435\u0434\u043e\u0441\u0442\u0430\u0432\u043b\u0435\u043d\u043d\u044b\u0435 \u0432\u0430\u043c\u0438 \u0434\u0430\u043d\u043d\u044b\u0435.",
      de: "Das XIMA-Team wird eine Geschenkkarte kaufen und sie an die von dir angegebenen Informationen senden.",
    },
    price: "100,000 X",
  },
  {
    id: "targeta-de-30",
    blockType: BLOCK_TYPE_SPECIAL,
    accessType: STORE_PRODUCT_ACCESS_PURCHASE,
    image: "/store/targeta-de-30.png",
    gallery: ["/store/targeta-de-30.png"],
    defaultPriceX: 150000,
    name: {
      es: "Tarjeta de 30",
      en: "Card Of 30",
      ru: "\u041a\u0430\u0440\u0442\u0430 \u0434\u043b\u044f 30",
      de: "Karte von 30",
    },
    description: {
      es: "El equipo de XIMA comprara una tarjeta de regalo y te la enviara a la informacion que proporciones.",
      en: "The XIMA team will purchase a gift card and send it to the information you provide.",
      ru: "\u041a\u043e\u043c\u0430\u043d\u0434\u0430 XIMA \u043f\u0440\u0438\u043e\u0431\u0440\u0435\u0442\u0451\u0442 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u0443\u044e \u043a\u0430\u0440\u0442\u0443 \u0438 \u043e\u0442\u043f\u0440\u0430\u0432\u0438\u0442 \u0435\u0451 \u043d\u0430 \u043f\u0440\u0435\u0434\u043e\u0441\u0442\u0430\u0432\u043b\u0435\u043d\u043d\u044b\u0435 \u0432\u0430\u043c\u0438 \u0434\u0430\u043d\u043d\u044b\u0435.",
      de: "Das XIMA-Team wird eine Geschenkkarte kaufen und sie an die von dir angegebenen Informationen senden.",
    },
    price: "150,000 X",
  },
];

const buildSkinProductBySkinId = (products = []) => {
  const map = new Map();

  products.forEach((product) => {
    const normalizedProductId = normalizeStoreProductId(product?.id);
    if (!normalizedProductId) return;

    const normalizedSkinIds = resolveSkinIdsFromStoreProductAssets(product);

    normalizedSkinIds.forEach((skinId) => {
      if (!map.has(skinId)) {
        map.set(skinId, {
          ...product,
          id: normalizedProductId,
          earnedMode: String(product?.earnedMode || "").trim().toLowerCase(),
          accessType:
            product?.accessType === STORE_PRODUCT_ACCESS_EARNED_TOP_PLAYER
              ? STORE_PRODUCT_ACCESS_EARNED_TOP_PLAYER
              : STORE_PRODUCT_ACCESS_PURCHASE,
        });
      }
    });
  });

  return map;
};

const buildProductById = (products = []) => {
  const map = new Map();
  products.forEach((product) => {
    const normalizedProductId = normalizeStoreProductId(product?.id);
    if (!normalizedProductId || map.has(normalizedProductId)) return;
    map.set(normalizedProductId, {
      ...product,
      id: normalizedProductId,
      earnedMode: String(product?.earnedMode || "").trim().toLowerCase(),
      accessType:
        product?.accessType === STORE_PRODUCT_ACCESS_EARNED_TOP_PLAYER
          ? STORE_PRODUCT_ACCESS_EARNED_TOP_PLAYER
          : STORE_PRODUCT_ACCESS_PURCHASE,
    });
  });
  return map;
};

export const SPECIAL_PRODUCT_BY_SKIN_ID = buildSkinProductBySkinId(SPECIAL_BLOCK_PRODUCTS);
export const COMMON_PRODUCT_BY_SKIN_ID = buildSkinProductBySkinId(COMMON_BLOCK_PRODUCTS);
export const MATERIAL_PRODUCT_BY_TEXTURE_ID = buildSkinProductBySkinId(MATERIAL_TEXTURE_PRODUCTS);
export const ANIMATION_PRODUCT_BY_ANIMATION_ID = buildSkinProductBySkinId(BLOCK_ANIMATION_PRODUCTS);
export const SPECIAL_PRODUCT_BY_ID = buildProductById(SPECIAL_BLOCK_PRODUCTS);
export const COMMON_PRODUCT_BY_ID = buildProductById(COMMON_BLOCK_PRODUCTS);
export const MATERIAL_PRODUCT_BY_ID = buildProductById(MATERIAL_TEXTURE_PRODUCTS);
export const ANIMATION_PRODUCT_BY_ID = buildProductById(BLOCK_ANIMATION_PRODUCTS);
export const GIFT_CARD_PRODUCT_BY_ID = buildProductById(GIFT_CARD_PRODUCTS);
const SPECIAL_PRODUCT_BY_ID_WITH_GIFT_CARDS = new Map([
  ...SPECIAL_PRODUCT_BY_ID.entries(),
  ...GIFT_CARD_PRODUCT_BY_ID.entries(),
]);

export const resolveSkinStoreProductForSkin = (blockType, skinId) => {
  const normalizedSkinId = normalizeSkinId(skinId);
  if (!normalizedSkinId) return null;
  if (String(blockType || "").trim().toLowerCase() === BLOCK_TYPE_COMMON) {
    return COMMON_PRODUCT_BY_SKIN_ID.get(normalizedSkinId) || null;
  }
  if (String(blockType || "").trim().toLowerCase() === BLOCK_TYPE_MATERIAL) {
    return MATERIAL_PRODUCT_BY_TEXTURE_ID.get(normalizedSkinId) || null;
  }
  if (String(blockType || "").trim().toLowerCase() === BLOCK_TYPE_ANIMATION) {
    return ANIMATION_PRODUCT_BY_ANIMATION_ID.get(normalizedSkinId) || null;
  }
  return SPECIAL_PRODUCT_BY_SKIN_ID.get(normalizedSkinId) || null;
};

export const resolveSkinStoreProductById = (productId, blockType = "") => {
  const normalizedProductId = normalizeStoreProductId(productId);
  if (!normalizedProductId) return null;
  if (String(blockType || "").trim().toLowerCase() === BLOCK_TYPE_COMMON) {
    return COMMON_PRODUCT_BY_ID.get(normalizedProductId) || null;
  }
  if (String(blockType || "").trim().toLowerCase() === BLOCK_TYPE_SPECIAL) {
    return (
      SPECIAL_PRODUCT_BY_ID.get(normalizedProductId) ||
      GIFT_CARD_PRODUCT_BY_ID.get(normalizedProductId) ||
      null
    );
  }
  if (String(blockType || "").trim().toLowerCase() === BLOCK_TYPE_MATERIAL) {
    return MATERIAL_PRODUCT_BY_ID.get(normalizedProductId) || null;
  }
  if (String(blockType || "").trim().toLowerCase() === BLOCK_TYPE_ANIMATION) {
    return ANIMATION_PRODUCT_BY_ID.get(normalizedProductId) || null;
  }
  return (
    SPECIAL_PRODUCT_BY_ID.get(normalizedProductId) ||
    GIFT_CARD_PRODUCT_BY_ID.get(normalizedProductId) ||
    COMMON_PRODUCT_BY_ID.get(normalizedProductId) ||
    MATERIAL_PRODUCT_BY_ID.get(normalizedProductId) ||
    ANIMATION_PRODUCT_BY_ID.get(normalizedProductId) ||
    null
  );
};

export const normalizeOwnedStoreProductIds = (rawValues, blockType) => {
  const source = Array.isArray(rawValues) ? rawValues : [];
  const productsMap =
    String(blockType || "").trim().toLowerCase() === BLOCK_TYPE_COMMON
      ? COMMON_PRODUCT_BY_ID
      : String(blockType || "").trim().toLowerCase() === BLOCK_TYPE_MATERIAL
      ? MATERIAL_PRODUCT_BY_ID
      : String(blockType || "").trim().toLowerCase() === BLOCK_TYPE_ANIMATION
      ? ANIMATION_PRODUCT_BY_ID
      : SPECIAL_PRODUCT_BY_ID_WITH_GIFT_CARDS;
  const allowed = new Map(
    Array.from(productsMap.entries()).filter(([, product]) =>
      (product?.accessType || STORE_PRODUCT_ACCESS_PURCHASE) === STORE_PRODUCT_ACCESS_PURCHASE
    )
  );
  const unique = new Set();
  source.forEach((candidate) => {
    const normalized = normalizeStoreProductId(candidate);
    if (!normalized || !allowed.has(normalized)) return;
    unique.add(normalized);
  });
  return Array.from(unique);
};
